import { useIsOneDriveIntegrationEnabledQuery } from 'store/api/dmsTeam';

/**
 * Whether a page whose cards are laid out by the OneDrive answer still waits for the first one. A failed answer
 * ends the wait: every new reader of a failed answer asks again, which reads as loading once more, and a page that
 * waited on that would drop its cards each time one of them, or a form of theirs, mounts.
 */
export const useIsAwaitingOneDrive = (options?: { skip?: boolean }) => {
    const { isLoading, error } = useIsOneDriveIntegrationEnabledQuery(undefined, options);
    return isLoading && !error;
};
